import { sortBy } from 'lodash';
import { useCallback, useMemo } from 'react';
import { isUserMeetingConfirmed } from '../../../filters/meetings/isUserMeetingConfirmed';
import { useMyUserId } from '../../sessionHooks';
import { useMeetings } from '../useMeetings';

/**
 * Returns an array of confirmed meetings for a given event, optionally filtered and sorted.
 *
 * @param {number} eventId - The ID of the event.
 * @param {Object} options - An optional object containing filter and sortBy functions.
 * @param {function} options.filter - A function that filters the meetings array.
 * @param {function} options.sortBy - A function that sorts the meetings array.
 * @return {Array} - An array of confirmed meetings for the given event, optionally filtered and sorted.
 */
export function useConfirmedMeetings(eventId, options = {}) {
    const { count, filter, sortBy: sortFunction } = options,
        selfUserId = useMyUserId(),
        isMyInviteConfirmedFilter = useCallback((meeting) => isUserMeetingConfirmed(selfUserId, meeting), [selfUserId]),
        meetings = useMeetings(eventId, { filter: isMyInviteConfirmedFilter });

    return useMemo(() => {
        let result = meetings;

        if (filter) result = result.filter(filter);
        if (sortFunction) result = sortBy(result, sortFunction);
        if (count) result = result.slice(0, count);

        return result;
    }, [meetings, count, filter, sortFunction]);
}
